// extracted by mini-css-extract-plugin
module.exports = {"heading":"ListTable_heading__2-TP0"};